import { DynamicText } from "./DynamicText";

export default DynamicText;
